import { useContext } from 'react';

import {
  Box,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';

import HeaderMenu from './EagleEye';
import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import Logo from 'src/components/LogoNeb';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 5;
        background-color: ${theme.header.background};
        box-shadow: ${theme.header.boxShadow};
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Box display="flex" alignItems="center" sx={{ minWidth: 0, overflow: 'hidden' }}>
        {/* Show Logo only on mobile (when sidebar is hidden) */}
        {!isDesktop && <Logo />}

        {/* Show HeaderMenu only on medium+ screens */}
        {!isMobile && <HeaderMenu />}
      </Box>
      <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
        <HeaderButtons />
        <HeaderUserbox />

        {/* Show menu toggle button only on mobile */}
        {!isDesktop && (
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar} size="small">
              {!sidebarToggle ? <MenuTwoToneIcon /> : <CloseTwoToneIcon />}
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
